module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.25.0@babel-runtime/core-js/promise.js
// module id = 45
// module chunks = 1